import { mockContactTitleOptions } from '@/lib/demo-data/contact-titles';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

interface ContactTitleLookupApi {
  code: string;
  name: string;
}

/**
 * Fetches the canonical ContactTitles lookup that every Title dropdown is built from.
 * The same lookup validates and corrects the Title column of a contact import, so the options
 * offered here are exactly the titles an import will accept.
 */
export function useContactTitles() {
  const { apiGet } = useApi();

  return useModeAwareQuery<string[], Error>(
    ['contact-titles'],
    async ({ signal }) => {
      const response = await apiGet<ContactTitleLookupApi[]>('/api/v1/contact-titles', undefined, signal);
      return response.map((x) => x.name);
    },
    mockContactTitleOptions,
    { staleTime: 60 * 1000, refetchOnWindowFocus: false },
  );
}
